module.exports = __webpack_public_path__ + "img/ico_order_total.2fadcbdb.svg";